import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Alert ,
  Button,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { DatetimePicker } from '../../../../../commons/controls';
import momentLocalizer from 'react-widgets-moment';
import Moment from 'moment';
import CikkSelect from '../CikkSelect';
import Lib from '../../../../../commons/lib';
import { PaginationTotal } from '../../../../../commons/controls';
import { ProgressButton } from '../../../../../commons/ProgressButton';
import NetworkEmptyState from '../../../../../commons/networkemptystate';
import TreeView from '../../../../../commons/Treeview';
import Loader from '../../../../../commons/loader';
import Services from '../services';
import getTooltip from './LeltarTooltips';
import getTooltipKeszlet from '../../../KeszletTooltips';
import CustomTooltip from '../../../../../components/Tooltip/CustomTooltip';

import 'moment/locale/hu';
import RFForm from '../../../../../components/Form/RFForm';
import RFField from '../../../../../components/Form/RFField';
import SelectField from '../../../../../components/Form/SelectField';
import TimeFormatter from '../../../../../commons/TimeFormatter';
import moment from 'moment';

// momentLocalizer(Moment);

class LeltarForm extends Component {
  constructor(props) {
    super(props);

    this.textInputRef = React.createRef();

    this.state = {
      leltarId: '',
      modositas: false,
      isAlertOpen: false,
      isAlertEditOpen: false,
      hasAllOldRaktarRoles: true,
      cikkTablePage: 1,
      cikkTablePageSize: 25,
      // FORM VALUES
      formCegadat: '',
      formCegadatOptions: [],
      formTitle: '-',
      formTipus: '',
      formLeltarModositasOptions: [],
      formHelyszin: '',
      formHelyszinOptions: [],
      formHatarido: TimeFormatter.formatDate(Moment()),
      formRaktar: '',
      formRaktarOptions: [],
      formFelelos: '',
      formFelelosNev: null,
      formFelelosOptions: [],
      baseJson: [],
      formTelefon: '',
      formEmail: '',
      formModalPenzintezet: '',
      formModalBankszamlaszam: '',
      formModalIbanszam: '',
      // -
      formFordulonap: Moment().startOf('day'),
      formBlokk: false,
      formMegjegyzes: '',
      formLeltarozasMod: '',
      formAllapotMegjegyzes: '',
      formAllapot: '',
      formCikkKereses: '',
      // MODAL UTILS
      modalBankadatTitle: '-',
      modalBankadatButtonText: '-',
      modalLeltariv: false,
      modalEdit: false,
      // FORM UTILS
      formAllapotOptions: [],
      lek: null,
      submitButtonLoading: false,
      bankButtonLoading: false,
      // STATUS UTILS
      // ['LOAD', 'DATA', 'NETW']
      formCardStatus: 'LOAD',
      leltariIvJson: [],
      expanded: [],
      cikkTree: [],
      modalCikk: false,
      cikkFilteredTree: [],
      cikkek: [],
      editmode: false,
      editobj: {},
      existsSzervezet: true,
      felelosok: [],

      selectedIndex: null,
      tableReseted: true,
      
      editButtonLoading: false,
    };
    this.selected = false;
    this.cikkSelectRef = React.createRef();
    this.cikkTableRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("click", this.handleDocumentClick);

    Services.listFelelos((err, res) => {
      if (!err) {
        this.setState({ felelosok: res[0] });
      }
    });
    if (this.props.type === 'MOD') {
      let params = new URL(window.location.href).searchParams;
      let id = params.get('id');
      this.setState({
        formTitle: 'Leltár módosítása',
        leltarId: id,
        modositas: true,
        lek: this.props && this.props.location && this.props.location.state && this.props.location.state.lek
      }, () => {
        this.initBejelentesForm(this.getLeltar, id);
      });
    }
    if (this.props.type === 'FEL') {
      this.setState({
        formTitle: 'Új leltár',
        // lek: this.props && this.props.location && this.props.location.state && this.props.location.state.lek
      }, () => {
        this.initBejelentesForm();
      });
    }
    this.getPenznem();
    this.checkRoles();
    this.isSzervezetExist();
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleDocumentClick);
  }

  checkRoles = () => {
    this.hasRoleKarb = this.props.globals.hasRole(['KESZLETNYILV_LELTAR'], true);
    this.hasRoleMennyRogz = this.props.globals.hasRoleSpec(['KESZLETNYILV_LELTAR_MENNYROGZ']);
  }

  isSzervezetExist = () => {
    Services.existsSzervezet((err, res) => {
      if (!err) {
        this.setState({ existsSzervezet: JSON.parse(res[0]) });
      }
    });
  }

  getPenznem = () => {
    Services.listAktivPenznem((err, res) => {
      if (!err) {
        let defaultPenznem = [];
        res[0].filter(x => x.defaultcurrency).forEach((item) => {
          defaultPenznem = item;
        });
        this.setState({
          penznem: defaultPenznem,
        });
      }
    });
  }

  toggleKorrekcioModal = () => {
    this.setState(prevState => ({ modalKorrekcio: !prevState.modalKorrekcio }));
  }

  toggleAlert = () => {
    this.setState(prevState => ({ isAlertOpen: !prevState.isAlertOpen }));
  }

  toggleAlertEdit = () => {
    this.setState(prevState => ({ isAlertEditOpen: !prevState.isAlertEditOpen }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  toggleEditModal = () => {
    this.setState(prevState => ({ modalEdit: !prevState.modalEdit, isAlertEditOpen: false }));
  }

  toggleLeltariv = (title) => {
    this.setState(prevState => ({ modalLeltariv: !prevState.modalLeltariv, modalLeltarivTitle: title, isAlertOpen: false }), () => {
      if (this.state.modalLeltariv) {
        Services.listBizonylatRaktar('LELTARIV', null, this.state.formCegadat, (err, res) => {
          if (!err) {
            const options = res[0];
            this.setState({
              formRaktarOptions: options
            });

            if(!this.state.formRaktar && options.length > 0) {
              this.handleRaktarChange(options[0]);
            }
          }
        });
        if (this.state.existsSzervezet) {
          Services.listSzemely((err, res) => {
            if (!err) {
              this.setState({
                formFelelosOptions: res[0]
              });
            }
          });
        }
      }
    });
  }

  toggleCikk = () => {
    if (this.state.editmode) this.setState({ editmode: false });
    this.setState({ modalCikk: !this.state.modalCikk });
  }

  // korrekcio = () => {
  //   this.setState({
  //     korrekcioButtonLoading: true
  //   });
  //   Services.getLeltarKorrekcio(this.state.leltarId, (err) => {
  //     if (!err) {
  //       this.toggleKorrekcioModal();
  //       this.getLeltar(this.state.leltarId);
  //       this.props.globals.addSuccess('A korrekció végrehajtásra került!');
  //       this.setState({
  //         korrekcioButtonLoading: false
  //       });
  //     } else {
  //       this.setState({
  //         korrekcioButtonLoading: false
  //       });
  //     }
  //   });
  // }

  edit = async () => {
    if ((this.state.existsSzervezet && (this.state.formFelelos === '' || !this.state.formFelelos)) || (!this.state.existsSzervezet && (this.state.formFelelosNev === '' || !this.state.formFelelosNev))) {
      this.setState({
        isAlertEditOpen: true,
      });
    } else {
      let leltarJSON = JSON.parse(JSON.stringify(this.state.leltariIvJson));
      await leltarJSON.forEach((leltariv) => {
        if (leltariv.id == this.state.currentEditId) {
          leltariv.szemely = this.state.existsSzervezet ? this.state.formFelelos : {nev: this.state.formFelelosNev.label};
        }
      });
      this.setState({
        leltariIvJson: leltarJSON,
        modalEdit: false
      });
    }
  }

  addCikk = (event, cikkObj) => {
    let leltarJSON = JSON.parse(JSON.stringify(this.state.leltariIvJson));
    try {
    leltarJSON.forEach((leltariv) => {
      if (leltariv.id == this.state.currentIv) {
        if (!cikkObj.egysegarnetto)
            throw 'A beszerzési ár megadása kötelező nem bevételezett cikk esetén!';
        leltariv.cikkek.push({
          parentid: leltariv.id,
          id: cikkObj.cikk.id,
          megnevezes: cikkObj.megnevezes,
          cikkSzam: cikkObj.cikkszam,
          leltarMennyiseg: cikkObj.mennyiseg,
          egysegarnetto: cikkObj.egysegarnetto,
          egysegarbrutto: cikkObj.egysegarbrutto,
          beszerzesnetto: cikkObj.beszerzesnetto,
          beszerzesbrutto: cikkObj.beszerzesbrutto,
          priceInputEgyseg: cikkObj.priceInputEgyseg,
          mennyisegiEgyseg: cikkObj.mennyisegiEgyseg,
          mennyiseg: '',
          keszleten: false
        });
        leltariv.cikkek.sort((cikk1, cikk2) => cikk1.cikkSzam.localeCompare(cikk2.cikkSzam));
        this.setState({ leltarIvCikkList: leltariv.cikkek });
      }
    });
    this.setState({
      leltariIvJson: leltarJSON
    }, () => {
      this.toggleCikk();
    });
  } catch (e) {
    this.props.globals.addError(e);
  }
}

  editCikk = (event, cikkObj) => {
    let edited = this.state.cikkek.find(keszletcikk => keszletcikk.cikkid === this.state.editobj.cikkid);
    this.state.cikkek[this.state.cikkek.indexOf(edited)] = cikkObj;
    this.setState({ cikkek: this.state.cikkek, editmode: false });
    this.toggleCikk();
  }

  initBejelentesForm = (callback, callbackParam) => {
    Services.listCegadatAktiv((err, res) => {
      if (!err) {
        this.setState({
          formCegadatOptions: res[0]
        }, () => {callback && callback(callbackParam)});
      }
    });
    Services.getLeltarInit((err, res) => {
      if (!err) {
        this.setState({
          formLeltarModositasOptions: res[0].mod,
          formCardStatus: 'DATA'
        });
      }
    });
  }

  renderHelyszinOptions = () => {
    return this.state.formHelyszinOptions.map((item) => {
      return (
        <option
          value={item.id}
          key={item.id}
        >
          {item.nev}
        </option>
      );
    });
  }

  renderTipusOptions = () => {
    return this.state.formTipusOptions.map((item) => {
      return (
        <option
          value={item.id}
          key={item.id}
        >
          {item.nev + ' (' + item.hatarido + ' óra)'}
        </option>
      );
    });
  }

  getLeltar = (id) => {
    this.setState({
      formCardStatus: 'LOAD',
      leltariIvJson: []
    }, () => {
      Services.getLeltar(id, (err, res) => {
        if (!err) {
          let leltarivJSON = [];
          res[0].leltarIvEntityList.forEach((leltariv) => {
            let leltarivObj = {};
            leltarivObj.id = leltariv.id;
            leltarivObj.bizonylat = leltariv.bizonylat;
            leltarivObj.raktar = leltariv.raktar;
            leltarivObj.szemely = leltariv.szemely;
            leltarivObj.rogzszemelynev = leltariv.uvd.rogzszemelynev;
            leltarivObj.rogzidopont = leltariv.rogzidopont;
            leltarivObj.cikkek = [];
            leltariv.leltarIvCikkEntityList.forEach((cikk) => {
              leltarivObj.cikkek.push({
                parentid: leltariv.id,
                id: cikk.cikk.id,
                leltarivcikkid: cikk.id,
                megnevezes: cikk.cikk.megnevezes,
                cikkSzam: cikk.cikk.cikkszam,
                leltarMennyiseg: cikk.leltarMennyiseg,
                egysegarnetto: cikk.egysegarnetto,
                egysegarbrutto: cikk.egysegarbrutto,
                beszerzesnetto: cikk.beszerzesnetto,
                beszerzesbrutto: cikk.beszerzesbrutto,
                mennyisegiEgyseg: cikk.cikk.mennyisegiEgyseg,
                mennyiseg: cikk.eredetiMennyiseg,
                keszleten: cikk.keszleten,
                modUserNev: cikk.modUserNev
              });
            });
            leltarivJSON.push(leltarivObj);
          });
          this.setState({
            // A null érték is false lesz a "!!"" konvertálás miatt
            hasAllOldRaktarRoles: !!res[0].hasalloldraktarroles,
            formCardStatus: 'DATA',
            formCegadat: res[0].cegadatid,
            // Módosításkor csak a fordulónap szerinti cégadat lesz mutatva
            formCegadatOptions: [res[0].cegadat],
            formFordulonap: TimeFormatter.formatDateTime(this.emptyOrNull(res[0].forduloDatum)),
            formBlokk: res[0].keszlet_blokk,
            formLeltarkezdete: res[0].leltarKezdete && TimeFormatter.formatDateTime(this.emptyOrNull(res[0].leltarKezdete)),
            formLeltarvege: res[0].leltarVege && TimeFormatter.formatDateTime(this.emptyOrNull(res[0].leltarVege)),
            formLeltarozasMod: res[0].mod && res[0].mod.name,
            formBizonylatSzam: res[0].bizonylat && res[0].bizonylat.bizonylatszam,
            formMegjegyzes: this.nullToString(res[0].megjegyzes),
            leltariIvJson: leltarivJSON,
          });
        }
      });
    });
  }

  addLeltar = (type) => {
    const {
      leltarId,
      modositas,
      formCegadat,
      formTipus,
      formMegjegyzes,
      formAllapot,
      formAllapotMegjegyzes,
      formFordulonap,
      formBlokk,
      formLeltarkezdete,
      formLeltarvege,
      formLeltarozasMod,
      existsSzervezet,
    } = this.state;
    let submitObj = {};

    this.setState({ submitButtonLoading: true });

    // if (modositas) submitObj.id = this.emptyOrNull(leltarId);

    submitObj.megjegyzes = this.emptyOrNull(formMegjegyzes);
    submitObj.forduloDatum = formFordulonap ? TimeFormatter.formatIso(this.emptyOrNull(formFordulonap)) : null;
    submitObj.keszlet_blokk = formBlokk;
    submitObj.leltarKezdete = formLeltarkezdete ? TimeFormatter.formatIso(this.emptyOrNull(formLeltarkezdete)) : null;
    submitObj.leltarVege = formLeltarvege ? TimeFormatter.formatIso(this.emptyOrNull(formLeltarvege)) : null;
    submitObj.mod = this.emptyOrNull(formLeltarozasMod);
    submitObj.cegadatid = formCegadat;

    let leltarIvEntityList = [];

    this.state.leltariIvJson.forEach((leltariv) => {
      let leltarIvCikkEntityList = [];

      leltariv.cikkek.forEach((cikk) => {
        leltarIvCikkEntityList.push({
          cikkId: cikk.id,
          id: modositas ? cikk.leltarivcikkid : null,
          egysegarnetto: cikk.keszleten ? null : cikk.egysegarnetto,
          egysegarbrutto: cikk.keszleten ? null : cikk.egysegarbrutto,
          beszerzesnetto: cikk.keszleten ? null : cikk.beszerzesnetto,
          beszerzesbrutto: cikk.keszleten ? null : cikk.beszerzesbrutto,
          priceInputEgyseg: cikk.keszleten ? null : cikk.priceInputEgyseg,
          leltarMennyiseg: cikk.leltarMennyiseg,
          keszleten: cikk.keszleten
        });
      });
      leltarIvEntityList.push({
        id: modositas && !leltariv.felvitt ? leltariv.id : null,
        raktarId: leltariv.raktar && leltariv.raktar.id,
        szemelyId: existsSzervezet ? leltariv.szemely && leltariv.szemely.id : null,
        szemelyNev: existsSzervezet ? null : leltariv.szemely.nev,
        leltarIvCikkEntityList: leltarIvCikkEntityList
      });
    });

    submitObj.leltarIvEntityList = leltarIvEntityList;

    if (modositas) {
      submitObj.id = leltarId;
      Services.editLeltar(submitObj, this.state.leltarId, (err, res) => {
        if (!err) {
          this.setState({ submitButtonLoading: false });
          this.props.globals.addSuccess('Leltár módosítva!');
          this.onBack();
        } else {
          this.setState({ submitButtonLoading: false });
        }
      });
    } else {
      Services.addLeltar(submitObj, (err, res) => {
        if (!err) {
          this.setState({ submitButtonLoading: false });
          this.props.globals.addSuccess('Leltár felvéve!');
          this.onBack();
        } else {
          this.setState({ submitButtonLoading: false });
        }
      });
    }
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  emptyToZero = (data) => {
    if (!data || data === '') return 0;
    return data;
  }

  onBack = () => {
    this.props.globals.route.navigate({
      pathname: this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles'),
      search: '?page=6',
      state: {
        lek: this.state.lek
      }
    })
    
    // this.props.history.push({
    //   pathname: this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles'),
    //   state: {
    //     lek: this.state.lek
    //   }
    // });
    // this.props.history.push(this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles?page=6'));
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  filterTree = (cikkFilter, cikkTreeParam) => {
    let cikkTree = cikkTreeParam;
    if (!cikkTree) cikkTree = JSON.parse(JSON.stringify(this.state.cikkTree));
    let filteredTree = [];
    cikkTree.forEach((cikkcsoport) => {
      let cikkek = [];
      let cikkcsoportObj = {...cikkcsoport};
      cikkcsoport.cikkek.forEach((cikk) => {
        if (cikk.name.toLowerCase().includes(cikkFilter.toLowerCase())) {
          cikkek.push(cikk);
        }
      });
      if (cikkek.length > 0) {
        cikkcsoportObj.cikkek = cikkek;
        cikkcsoportObj.children = cikkek;
        cikkcsoportObj.isExpanded = true;
        filteredTree.push(cikkcsoportObj);
      }
    });
    return filteredTree;
  }

  handleCikkFilter = (e, cikkTree) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    if (true) { // value.length > 1
      let result = this.filterTree(value, cikkTree);
      this.setState({
        [name]: value,
        cikkFilteredTree: result
      });
    } else {
      this.setState({
        [name]: value
      });
    }
  }

  handleOraInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value,
      formHatarido: Moment().add(value, 'hours')
    });
  }

  handleTipusInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;

    let hours = 0;

    this.state.formTipusOptions.forEach((tipus) => {
      if (tipus.id == value) hours = tipus.hatarido;
    });

    this.setState({
      [name]: value,
      formOra: hours,
      formHatarido: Moment().add(hours, 'hours')
    });
  }

  handleDateInputChange = (e, v, name) => {
    if (this.selected) {
      this.selected = false;
      switch (name) {
        case 'formFordulonap':
          if (!e)
            e = new Date();
          else
            e = moment(e).startOf('day');
        case 'formLeltarkezdete':
          if (e)
            e = moment(e).startOf('day');
          break;
        case 'formLeltarvege':
          if (e)
            e = moment(e).endOf('day');
          break;
      }
    }
    this.setState({
      [name]: e
    });
  }

  getCorrectTextColor = (hex) => {
    /*
    From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

    Color brightness is determined by the following formula:
    ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

    I know this could be more compact, but I think this is easier to read/explain.

    */

    let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

    function cutHex(h) { return (h.charAt(0) === '#') ? h.substring(1, 7) : h; }
    function hexToR(h) { return parseInt((cutHex(h)).substring(0, 2), 16); }
    function hexToG(h) { return parseInt((cutHex(h)).substring(2, 4), 16); }
    function hexToB(h) { return parseInt((cutHex(h)).substring(4, 6), 16); }

    let hRed = hexToR(hex);
    let hGreen = hexToG(hex);
    let hBlue = hexToB(hex);

    let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
    if (cBrightness > threshold) { return '#000000'; } return '#ffffff';
  }

  allapotFormatter = (cell, row) => {
    return (
      <span style={{
        color: this.getCorrectTextColor('#' + row.szin)
      }}
      >
        {cell}
      </span>
    );
  }

  timezoneToDate = (date) => {
    if (!date || date === '') return null;
    return TimeFormatter.format(date, "lll:ss");
  }

  renderTable = () => {
    const columns = [
      {
        dataField: 'mod',
        text: 'Módosítás időpontja',
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        formatter: this.timezoneToDate,
        sort: false
      },
      {
        dataField: 'allapot',
        text: 'Állapot',
        style: (cell, row, rowIndex, colIndex) => {
          return {
            wordBreak: 'break-all',
            whiteSpace: 'pre-line',
            backgroundColor: '#' + row.szin
          };
        },
        formatter: this.allapotFormatter,
        sort: false
      },
      {
        dataField: 'moduser',
        text: 'Módosító',
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: false
      },
      {
        dataField: 'megjegyzes',
        text: 'Megjegyzés',
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: false
      },
      {
        dataField: 'id',
        text: '-',
        hidden: true
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          wrapperClasses="table-responsive"
          classes="table-scroll"
          headerClasses="table-th"
          filter={filterFactory()}
          // pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  renderLeltarModositasOptions = () => {
    return this.state.formLeltarModositasOptions.map((item) => {
      return (
        <option
          value={item.name}
          key={item.name}
        >
          {item.caption}
        </option>
      );
    });
  }

  renderCegadatOptions = () => {
    return this.state.formCegadatOptions.map((item) => {
      return (
        <option
          value={item.id}
          key={item.id}
        >
          {item.nev || item.teljesnev}
        </option>
      );
    });
  }

  renderFormCardLogic = () => {
    const {
      modositas,
      formCegadat,
      formTipus,
      formAzonosito,
      formHelyszin,
      formHatarido,
      formOra,
      formBejelento,
      formTelefon,
      formEmail,
      formBejelentes,
      formMegjegyzes,
      formAllapot,
      formLeltarozasMod,
      formBizonylatSzam,
      formFordulonap,
      formLeltarkezdete,
      formLeltarvege
    } = this.state;

    const titleStyle = {
      marginBottom: 20,
      marginTop: 10
    };

    return (
      <React.Fragment>
        {/* <div className="row">
          <div className="col-md-12">
            <TreeView
              data={this.state.data}
              onUpdateCb={(updatedData)=>{
                this.setState({data: updatedData})
              }}
              isCheckable={(node, depth)=>{
                // hide checkbox for all nodes of depth 1
                // or for node with the id of `1`
                // NOTE: The highest depth is 0, node children are depth+1
                if (depth === 0) {
                  return false;
                } else {
                  return true;
                }
              }}
              onCheckToggleCb={(arrayOfNodes, depth)=>{
                const nodeCount = arrayOfNodes.length;
                const status = (arrayOfNodes[0].isChecked)? 'checked': 'unchecked';
                alert(`${nodeCount} node(s) will be ${status} `);
              }}
            />
          </div>
            </div> */}
        <div className="row">
          <div className="col-md-3">
            <RFField
              label="Cégadat: *"
              tooltip={<CustomTooltip text={getTooltip('cegadat')} id="cegaadatTT" />}
              type="select"
              name="formCegadat"
              value={formCegadat}
              onChange={this.handleInputChange}
              defaultSelect={<option value="">Válassz cégadatot...</option>}
              selectOptions={this.renderCegadatOptions()}
              disabled={this.props.type === 'MOD' || (!this.hasRoleKarb || (this.state.leltariIvJson && this.state.leltariIvJson.length !== 0) || !this.state.hasAllOldRaktarRoles)}
            />
          </div>
          <div className='w-100' />
          <div className="col-md-3">
            <DatetimePicker
              label={'Fordulónap: *'}
              tooltip={<CustomTooltip text={getTooltip('formfordulonap')} id="formfordulonapTT" />}
              containerClassName="organw-date-time"
              // format="YYYY-MM-DD HH:mm:ss"
              time
              messages={{ dateButton: 'dátum', timeButton: 'idő' }}
              onChange={(e, v) => this.handleDateInputChange(e, v, 'formFordulonap')}
              onSelect={() => { this.selected = true }}
              value={formFordulonap && new Date(formFordulonap)}
              name="formFordulonap"
              id="formFordulonap"
              disabled={!this.hasRoleKarb || (this.state.leltariIvJson && this.state.leltariIvJson.length !== 0) || !this.state.hasAllOldRaktarRoles}
              timePrecision="seconds"
            />
          </div>
          <div className="col-md-3">
            <DatetimePicker
              label={'Leltár kezdete:'}
              tooltip={<CustomTooltip text={getTooltip('formkezdet')} id="formkezdetTT" />}
              containerClassName="organw-date-time"
              // format="YYYY-MM-DD HH:mm:ss"
              time
              messages={{ dateButton: 'dátum', timeButton: 'idő' }}
              onChange={(e, v) => this.handleDateInputChange(e, v, 'formLeltarkezdete')}
              onSelect={() => { this.selected = true }}
              value={formLeltarkezdete && new Date(formLeltarkezdete)}
              name="formLeltarkezdete"
              id="formLeltarkezdete"
              disabled={!this.hasRoleKarb || !this.state.formBlokk || !this.state.hasAllOldRaktarRoles}
              timePrecision="seconds"
            />
          </div>
          <div className="col-md-3">
            <DatetimePicker
              label={'Leltár vége:'}
              tooltip={<CustomTooltip text={getTooltip('formvege')} id="formvegeTT" />}
              containerClassName="organw-date-time"
              // format="YYYY-MM-DD HH:mm:ss"
              time
              messages={{ dateButton: 'dátum', timeButton: 'idő' }}
              onChange={(e, v) => this.handleDateInputChange(e, v, 'formLeltarvege')}
              onSelect={() => { this.selected = true }}
              value={formLeltarvege && new Date(formLeltarvege)}
              name="formLeltarvege"
              id="formLeltarvege"
              disabled={!this.hasRoleKarb || !this.state.formBlokk || !this.state.hasAllOldRaktarRoles}
              timePrecision="seconds"
            />
          </div>
          </div>
          <div className='row'>
            <div className="col-md-3">
              <RFField
                label="Leltározás módja: *"
                type="select"
                name="formLeltarozasMod"
                // required
                value={formLeltarozasMod}
                disabled={this.state.modositas || !this.state.hasAllOldRaktarRoles}
                onChange={this.handleInputChange}
                defaultSelect={<option value="">Válassz módot...</option>}
                selectOptions={this.renderLeltarModositasOptions()}
              />
            </div>
            {modositas && (
            <div className="col-md-3">
              <RFField
                label={'Bizonylatszám:'}
                id="formBizonylatSzam"
                name="formBizonylatSzam"
                value={formBizonylatSzam}
                disabled
              />
            </div>
          )}
          <div className="col-md-3">
            <Label check style={{ marginTop: '35px' }}>
              <Input
                type="checkbox"
                id="blokk"
                name="blokk"
                checked={this.state.formBlokk}
                style={{ marginTop: '5px' }}
                onChange={(val) => { this.setState({ formBlokk: val.target.checked, formLeltarkezdete: null, formLeltarvege: null }); }}
                disabled={!this.hasRoleKarb || !this.state.hasAllOldRaktarRoles}
              />
              {' '}
              <span style={{ paddingLeft: '17px' }}>
                Forgalom blokkolása
                <CustomTooltip text={getTooltip('formblokk')} id="formblokkTT" />
              </span>
            </Label>
          </div>
        </div>    
        <div className="row">
          <div className="col-md-6">
            <RFField
              label="Megjegyzés:"
              type="text"
              name="formMegjegyzes"
              maxLength="350"
              value={formMegjegyzes}
              onChange={this.handleInputChange}
              disabled={!this.hasRoleKarb || !this.state.hasAllOldRaktarRoles}
            />
          </div>
        </div>
        {this.hasRoleKarb && (
          <div className="row">
            <div className="col-md-12">
              <Button
                type="button"
                color="success"
                disabled={!this.state.formCegadat || !this.state.formFordulonap}
                onClick={() => {
                  this.setState({
                    formRaktar: '',
                    formRaktarOptions: [],
                    formFelelos: '',
                    formFelelosNev: null,
                    formFelelosOptions: [],
                    formCikkKereses: '',
                    cikkTree: [],
                    cikkFilteredTree: []
                  }, () => {
                    this.toggleLeltariv('Új leltárív');
                  });
                }}
              >
                Új leltárív
              </Button>
            </div>
          </div>
        )}
        <CikkSelect
          isOpen={this.state.modalCikk}
          toggle={this.toggleCikk}
          add={this.addCikk}
          cikkek={this.state.cikkek}
          editmode={this.state.editmode}
          editobj={this.state.editobj}
          edit={this.editCikk}
          globals={this.props.globals}
          price
          raktarId={this.state.currentRaktarId}
          fromLeltar
          excludeCikkIds={this.state.excludeCikkIds}
          ref={this.cikkSelectRef}
          penznem={this.state.penznem}
        />
      </React.Fragment>
    );
  }

  renderFormCard = () => {
    const cardStyle = {
      padding: 20
    };

    return (
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            {this.state.formTitle}
          </div>
          <RFForm onSubmit={() => {}}>
            <div style={cardStyle}>
              {{
                LOAD: (<div className="col-md-12"><Loader /></div>),
                NETW: (<NetworkEmptyState
                  hasImage
                  submitClick={() => this.getBejelentes(this.state.leltarId)}
                />),
                DATA: (this.renderFormCardLogic())
              }[this.state.formCardStatus]}
            </div>
          </RFForm>
          <div style={{ paddingBottom: 20, paddingLeft: 20, paddingRight: 20, paddingTop: 0 }} >
            <div className="row">
              <div className="col-md-12">
                {this.state.leltariIvJson.length > 0 && this.renderLeltarIvTable()}
                {this.state.leltarIvCikkList?.length > 0 && this.renderLeltarIvCikkTable()}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12" style={{ marginTop: 16 }}>
                <ProgressButton
                  className="btn-cursor-pointer"
                  color="primary"
                  loading={this.state.submitButtonLoading}
                  onClick={() => this.addLeltar('NORMAL')}
                >
                  {'Mentés'}
                </ProgressButton>
                {' '}
                {/* {this.state.modositas && (
                  <React.Fragment>
                    {this.props.globals.hasRoleSpec(['KESZLETNYILV_LELTAR_KORREKCIO']) && (
                      <ProgressButton
                        className="btn-cursor-pointer"
                        color="success"
                        loading={this.state.submitButtonLoading}
                        onClick={() => { this.toggleKorrekcioModal(); }}
                      >
                        {'Korrekció'}
                      </ProgressButton>
                    )}
                    {' '}
                  </React.Fragment>
                )} */}
                <Button type="button" color="secondary" onClick={() => { this.onBack(); }}>Vissza</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleRaktarChange = (value) => {
    if (value && value.length !== 0) {
      this.setState({ formRaktar: value, hasMennyisegCheckbox: false });
      let excludecikkids = [];
      this.state.leltariIvJson.forEach((leltariv) => {
        if (leltariv.raktar && leltariv.raktar.id == value.id)
          leltariv.cikkek.forEach((cikk) => {
            excludecikkids.push(cikk.id);
          });
      });
      Services.getLeltarCikk(value.id, excludecikkids, this.state.formFordulonap && new Date(this.state.formFordulonap), (err, res) => {
        if (!err) {
          let cikkTree = res[0];
          cikkTree.forEach((cikkcsoport) => {
            cikkcsoport.isExpanded = true;
            cikkcsoport.name = cikkcsoport.nev;
            cikkcsoport.cikkek.forEach((cikk) => {
              cikk.name = cikk.megnevezes;
            });
            cikkcsoport.children = cikkcsoport.cikkek;
          });
          this.setState({
            cikkTree,
            cikkFilteredTree: cikkTree
          });
        }
      });
    } else {
      this.setState({ formRaktar: '' });
    }
  }

  handleFelelosChange = (value) => {
    if (value && value.length !== 0) {
      this.setState({ formFelelos: value });
    } else {
      this.setState({ formFelelos: '' });
    }
  }

  handleFelelosNevChange = (nev) => {
    if (!nev) {
      this.setState({ formFelelosNev: null });
    } else {
      this.setState({ formFelelosNev: { value: nev, label: nev } });
    }
  }

  toggleCikkCheck = (cikkid) => {
    this.setState((prevState) => {
      let { cikkTree } = prevState;
      cikkTree.forEach((cikkcsoport) => {
        cikkcsoport.cikkek.forEach((cikk) => {
          if (cikk.id == cikkid) {
            cikk.isChecked = !cikk.isChecked;
          }
        });
      });
      return { cikkTree };
    });
  }

  handleEditClick = (leltariv) => {
    if (this.state.existsSzervezet) {
      Services.listSzemely((err, res) => {
        if (!err) {
          this.setState({
            currentEditId: leltariv.id,
            formFelelos: leltariv.szemely,
            formFelelosOptions: res[0]
          }, () => {
            this.toggleEditModal();
          });
        }
      });
    } else {
      this.setState({
        currentEditId: leltariv.id,
        formFelelosNev: { value: leltariv.szemely.nev, label: leltariv.szemely.nev },
      }, () => {
        this.toggleEditModal();
      });
    }
  }

  delete = () => {
    if (this.state.deleteObj.type === 'LELTARIV') {
      let array = this.state.leltariIvJson.filter((item) => {
        return item.id !== this.state.deleteObj.id;
      });
      if (this.state.deleteObj.id == this.state.currentRow)
        this.setState({ leltarIvCikkList: [] });

      this.setState({
        leltariIvJson: array
      }, () => {
        this.toggleDeleteModal();
      });
    } else if (this.state.deleteObj.type === 'CIKK') {
      let leltariIvJson = JSON.parse(JSON.stringify(this.state.leltariIvJson));
      leltariIvJson.forEach((leltariv) => {
        if (leltariv.id == this.state.deleteObj.parentid) {
          leltariv.cikkek = leltariv.cikkek.filter((item) => {
            return item.id !== this.state.deleteObj.id;
          });
        }
      });

      this.setState({
        leltariIvJson: leltariIvJson,
        leltarIvCikkList: leltariIvJson.find(x => x.id == this.state.currentRow).cikkek
      }, () => {
        this.toggleDeleteModal();
      });
    }
  }

  handleLeltarIvDelete = (id) => {
    this.setState({
      deleteObj:
        {
          type: 'LELTARIV',
          id: id
        }
    }, () => {
      this.toggleDeleteModal();
    });
  }

  handleLeltarCikkDelete = (id, row) => {
    this.setState({
      deleteObj:
        {
          type: 'CIKK',
          id: id,
          parentid: row.parentid
        }
    }, () => {
      this.toggleDeleteModal();
    });
  }

  formatCreateLabel = (input) => {
    return (
      <span>
        <i>Hozzáadás: </i>
        {' '}
        {input}
      </span>
    );
  };

  createFelelos = (nev) => {
    let array = this.state.felelosok.filter(felelos => felelos != nev);
    array.push(nev);
    this.setState({
      felelosok: array,
      formFelelosNev: { value: nev, label: nev },
    });
  }

  // A mutatott oldalszám és oldalméret alapján az a szám, amivel az indexet el kell tolni,
  // hogy az aktív oldalhoz relatív indexből abszolút indexet lehessen számolni
  getCikkTableIndexCorrection = () => {
    return (this.state.cikkTablePage - 1) * this.state.cikkTablePageSize;
  }

  leltarIvFormatter = (cell, row) => {
    return (
      <div>
        {
          <React.Fragment>
            {/* <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'view'} onClick={() => {}} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'view'} delay={50}>
              {'Megtekintés'}
            </UncontrolledTooltip> */}
            {this.hasRoleKarb && (
              <React.Fragment>
                <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => { this.handleEditClick(row); }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                  {'Módosítás'}
                </UncontrolledTooltip>
                {/* <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                  {'Módosítás'}
                </UncontrolledTooltip> */}
                <Button className="icon-trash table-action-icon" id={'action-delete-' + cell + 'leltariv'} onClick={() => this.handleLeltarIvDelete(cell)} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-delete-' + cell + 'leltariv'} delay={50}>
                  {'Törlés'}
                </UncontrolledTooltip>
              </React.Fragment>
            )}
            {(this.hasRoleMennyRogz || this.hasRoleKarb) && (
              <React.Fragment>
                <Button
                  className="table-action-icon"
                  id={'action-add-' + cell + 'cikk'}
                  onClick={() => {
                    this.cikkSelectRef.current.clearValues();
                    this.setState((prevState) => {
                      let leltarIv = prevState.leltariIvJson.find(iv => iv.id == cell);
                      let excludeCikkIds = [];
                      prevState.leltariIvJson.filter(x => x.raktar.id == row.raktar.id).forEach(leltariv => excludeCikkIds = excludeCikkIds.concat(leltariv.cikkek.map(cikk => cikk.id)));
                      return {
                        currentIv: cell,
                        currentRaktarId: row.raktar.id,
                        excludeCikkIds: excludeCikkIds
                      };
                    }, () => {
                      this.toggleCikk();
                    });
                  }}
                >
                  <i class="fa fa-plus" />
                </Button>
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-add-' + cell + 'cikk'} delay={50}>
                  {'Cikk hozzáadása'}
                </UncontrolledTooltip>
              </React.Fragment>
            )}
          </React.Fragment>
      }
      </div>
    );
  }

  leltarCikkFormatter = (cell, row) => {
    return (
      <div>
        {this.hasRoleKarb && (
          <React.Fragment>
            <Button className="icon-trash table-action-icon" id={'action-delete-' + cell + 'leltarcikk'} onClick={() => { this.handleLeltarCikkDelete(cell,row) }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-delete-' + cell + 'leltarcikk'} delay={50}>
              {'Törlés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  handleDocumentClick = (e) => {
    if(!this.state.leltarIvCikkList || this.state.leltarIvCikkList.length == 0) return;
    if(this.state.selectedIndex === null) return;

    const attrId = e.target.getAttribute('id');
    if(attrId && (attrId.startsWith('amount-input-') || attrId.startsWith('amount-div-'))) {
      return;
    }

    this.setState({ selectedIndex: null, inputValue: '' }, () => {
      this.resetTable();
    });
  }

  onInputBlur = (leltariIvJson, leltarivid, cikkid, value) => {
    if (isNaN(value)) {
      this.props.globals.addError('A mező csak számot tartalmazhat!');
      return;
    }
    this.setState({ selectedIndex: null });
    let leltariv = leltariIvJson.find(x => x.id == leltarivid);
    if (leltariv)
      leltariv.cikkek.find(x => x.id == cikkid).leltarMennyiseg = value;
  }

  editFormatter = (cell, row, rowIndex, formatExtraData) => {
    if (rowIndex === this.state.selectedIndex) {
      return (
        <input
          id={`amount-input-${rowIndex}`}
          style={{ width: '100%' }}
          ref={this.textInputRef}
          value={formatExtraData.inputValue ?? ''}
          onBlur={() => this.onInputBlur(formatExtraData.leltariIvJson, formatExtraData.currentRow, row.id, formatExtraData.inputValue)}
          onChange={(e) => this.setState({ inputValue: e.target.value })}
        />
      );
    }

    return cell;
  };

  setSelectedRow = (cikk, index) => {
    if(!cikk) return;

    this.setState(
      {
        selectedIndex: index,
        inputValue: cikk.leltarMennyiseg
      },
      () => {
        this.resetTable();
      }
    );
  };

  resetTable = () => {
    this.setState({ tableReseted: false }, () => {
      this.setState({ tableReseted: true }, () => {
        if (this.textInputRef.current) {
          this.textInputRef.current.focus();
        }
      });
    });
  };

  handleKeyDown = (event) => {
    if (event.key === 'Tab' || event.key === 'Enter') {
      event.preventDefault();
      let shift = event.shiftKey;
      let leltariv;
      let error = false;
      let leltarivCikkek = this.cikkTableRef.current.paginationContext.props.data;
      if (this.state.selectedIndex !== null) {
        if (isNaN(this.state.inputValue)) {
          this.props.globals.addError('A mező csak számot tartalmazhat!');
          error = true;
        } else {
          leltariv = this.state.leltariIvJson.find(x => x.id == this.state.currentRow);
          leltarivCikkek[this.getCikkTableIndexCorrection() + this.state.selectedIndex].leltarMennyiseg = this.state.inputValue;
          this.setState({ inputValue: null });
        }
      }
      let isLastPage = false;
      if (leltariv)
        isLastPage = Math.ceil(leltarivCikkek.length / this.state.cikkTablePageSize) == this.state.cikkTablePage;
      if (this.state.selectedIndex === null) {
        this.setState({ selectedIndex: 0 }, () => {
          this.tabNavCallback();
          this.resetTable();
        });
      } else if (!error && this.state.selectedIndex + 1 == (isLastPage ? leltarivCikkek.length % this.state.cikkTablePageSize : this.state.cikkTablePageSize)  && !event.shiftKey) {
        this.setState({ selectedIndex: 0 }, () => {
          this.tabNavCallback();
          this.resetTable();
        });
      } else if (!error && this.state.selectedIndex == 0 && event.shiftKey) {
        // Ha az utolsó oldalon van, akkor az utolsó elem kell amit listaméret modulo oldalméret ad meg, egyébként meg oldalméret (ami az oldalon az utolsó elem)
        let index = isLastPage ? leltarivCikkek.length % this.state.cikkTablePageSize : this.state.cikkTablePageSize;
        this.setState({ selectedIndex: index - 1}, () => {
          this.tabNavCallback();
          this.resetTable();
        });
      } else if (!error) {
        this.setState(
          prevState => ({
            selectedIndex: prevState.selectedIndex + (shift ? -1 : 1),
          }),
          () => {
            this.tabNavCallback();
            this.resetTable();
          }
        );
      } else if (error) {
        this.resetTable();
      }
    }
  }

  tabNavCallback = () => {
    let cikk = this.cikkTableRef.current.paginationContext.props.data[this.getCikkTableIndexCorrection() + this.state.selectedIndex];
    this.setState({ inputValue: cikk.leltarMennyiseg });
  }

  onRowSelect = (row) => {
    this.setState({ leltarIvCikkList: row.cikkek, currentRow: [row.id] });
  }

  renderLeltarIvTable = () => {
    let selectRowProp = {
      mode: 'radio',
      onSelect: this.onRowSelect,
      selected: this.state.currentRow,
      clickToSelect: true
    };

    const columns = [
      {
        dataField: 'bizonylat.bizonylatszam',
        text: 'Bizonylatszám',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'raktar.nev',
        text: 'Raktár',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'szemely.nev',
        text: 'Felelős',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
      },
      {
        dataField: 'rogzszemelynev',
        text: 'Rögzítő személy',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
      },
      {
        dataField: 'rogzidopont',
        text: 'Rögzítési időpont',
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
        formatter: rogzidopont => rogzidopont && TimeFormatter.format(rogzidopont, "YYYY.MM.DD HH:mm:ss")
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.leltarIvFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.leltariIvJson}
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
          selectRow={selectRowProp}
        />
      </div>
    );
  }

  renderLeltarIvCikkTable = () => {
    let columns = [
      {
        dataField: 'cikkSzam',
        text: 'Cikkszám',
        style: {
          whiteSpace: 'pre-line'
        },
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        editable: false
      },
      {
        dataField: 'megnevezes',
        text: 'Megnevezés',
        style: {
          whiteSpace: 'pre-line'
        },
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        editable: false
      },
      {
        dataField: 'mennyisegiEgyseg',
        text: 'Mennyiségi egység',
        style: {
          whiteSpace: 'pre-line'
        },
        align: 'center',
        editable: false
      },
      this.state.formLeltarozasMod !== 'VAK' ? {
        dataField: 'mennyiseg',
        text: 'Mennyiség',
        style: {
          whiteSpace: 'pre-line'
        },
        align: 'right',
        editable: false,
        headerFormatter: (column, colIndex, components) => <>{column.text}{components.sortElement}<CustomTooltip text={getTooltip('cikkmennyiseg')} id="cikkmennyisegTT" />{components.filterElement}</>,
      } : {},
      {
        dataField: 'leltarMennyiseg',
        text: 'Leltározott mennyiség',
        formatter: this.editFormatter,
        formatExtraData: this.state,
        validator: (newValue, row, column) => {
          if (isNaN(newValue)) {
            return {
              valid: false,
              message: 'A mező csak számot tartalmazhat!'
            };
          }
          return true;
        },
        align: 'right',
        attrs: (cell, row, rowIdx) => ({
          id: `amount-div-${rowIdx}`,
        }),
        events: {
          onClick: (e, c, ci, row, rowIndex) => { 
            this.setSelectedRow(row, rowIndex); }
        },
        headerFormatter: (column, colIndex, components) => <>{column.text}{components.sortElement}<CustomTooltip text={getTooltip('cikkleltarozott')} id="cikkleltarozottTT" />{components.filterElement}</>,
        // filter: textFilter({
        //   delay: 400, // default is 500ms
        //   placeholder: 'Keresés...',
        // }),
        // style: {
        //   whiteSpace: 'pre-line'
        // }
        // editable: true
      },
      {
        dataField: 'modUserNev',
        text: 'Módosító személy',
        style: {
          whiteSpace: 'pre-line'
        },
        editable: false
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        hidden: !this.hasRoleKarb,
        formatter: this.leltarCikkFormatter
      }
    ];

    return (
      <div className="animated fadeIn" onKeyDown={this.handleKeyDown}>
        <h5>Cikkek:</h5>
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.leltarIvCikkList}
          columns={columns}
          filter={filterFactory()}
          ref={this.cikkTableRef}
          pagination={paginationFactory({
            ...Lib.bootstraptableProps,
            sizePerPage: this.state.cikkTablePageSize,
            onPageChange: (page, sizePerPage) => { this.setState({ cikkTablePage: page, cikkTablePageSize: sizePerPage }); },
            onSizePerPageChange: (sizePerPage, page) => { this.setState({ cikkTablePage: page, cikkTablePageSize: sizePerPage }); },
          })}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  uuidv4 = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
  }

  submitLeltariv = () => {
    if (!this.emptyOrNull(this.state.formRaktar) || (this.state.existsSzervezet && !this.emptyOrNull(this.state.formFelelos)) || (!this.state.existsSzervezet && !this.emptyOrNull(this.state.formFelelosNev))) {
      this.setState({
        isAlertOpen: true
      });
    } else {
      let cikkTree = JSON.parse(JSON.stringify(this.state.cikkTree));
      let cikkek = [];
      let uuid = this.uuidv4();

      cikkTree.forEach((cikkcsoport) => {
        cikkcsoport.cikkek.forEach((cikk) => {
          if (cikk.isChecked) {
            cikkek.push({
              id: cikk.id,
              parentid: uuid,
              megnevezes: cikk.megnevezes,
              cikkSzam: cikk.cikkSzam,
              leltarMennyiseg: '',
              egysegarnetto: '',
              egysegarbrutto: '',
              beszerzesnetto: '',
              beszerzesbrutto: '',
              mennyisegiEgyseg: cikk.mennyisegiEgyseg,
              mennyiseg: cikk.mennyiseg,
              keszleten: true
            });
          }
        });
      });

      cikkek.sort((cikk1, cikk2) => cikk1.cikkSzam.localeCompare(cikk2.cikkSzam));
      let leltarivObj = {
        id: uuid,
        felvitt: true,
        raktar: this.state.formRaktar,
        szemely: this.state.existsSzervezet ? this.state.formFelelos : { nev: this.state.formFelelosNev.label },
        cikkek: cikkek
      };

      this.setState(prevState => ({
        leltariIvJson: [...prevState.leltariIvJson, leltarivObj]
      }), () => {
        this.toggleLeltariv('');
      });
    }
  }

  cikkcsoportFunc = (cikkcsoport, prevState) => {
    let cikkcsoportUnticked = false;
    cikkcsoport.children.forEach((cikk) => {
      if (cikk.mennyiseg > 0) {
        cikk.isChecked = !prevState.hasMennyisegCheckbox;
        if (prevState.hasMennyisegCheckbox) cikkcsoportUnticked = true;
      }
    });
    cikkcsoport.cikkek.forEach((cikk) => {
      if (cikk.mennyiseg > 0) {
        cikk.isChecked = !prevState.hasMennyisegCheckbox;
        if (prevState.hasMennyisegCheckbox) cikkcsoportUnticked = true;
      }
    });
    // Ha valamelyik cikktől el lett véve a pipa, akkor a cikkcsoporton is törli
    if (cikkcsoportUnticked) cikkcsoport.isChecked = false;
  }

  handleCheckAllMennyisegToggle = () => {
    this.setState((prevState) => {
      let cikkTree = JSON.parse(JSON.stringify(prevState.cikkTree));
      let cikkFilteredTree = JSON.parse(JSON.stringify(prevState.cikkFilteredTree));
      cikkTree.forEach(cikkcsoport => this.cikkcsoportFunc(cikkcsoport, prevState));
      cikkFilteredTree.forEach(cikkcsoport => this.cikkcsoportFunc(cikkcsoport, prevState));
      return { cikkTree, cikkFilteredTree, hasMennyisegCheckbox: !prevState.hasMennyisegCheckbox };
    });
  }

  render() {
    const {
      formModalBankszamlaszam,
      formModalPenzintezet,
      formModalIbanszam,
      formRaktar,
      formRaktarOptions,
      formFelelos,
      formFelelosNev,
      formFelelosOptions,
      formCikkKereses,
      isAlertOpen,
      isAlertEditOpen,
      existsSzervezet,
    } = this.state;

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            {this.renderFormCard()}
          </div>
        </div>
        <Modal isOpen={this.state.modalLeltariv} toggle={() => this.toggleLeltariv('')} backdrop="static" size="lg">
          <RFForm
            modal
            onSubmit={this.submitLeltariv}
            title={this.state.modalLeltarivTitle}
            footer={
              <>
                <ProgressButton color="primary" loading={false}>{'Hozzáadás'}</ProgressButton>
                <Button type="button" color="secondary" onClick={() => this.toggleLeltariv('')}>Mégsem</Button>
              </>
            }
          >
            <div className="row">
              <div className="col-md-12">
                <Alert color="danger" isOpen={isAlertOpen} toggle={this.toggleAlert}>
                  Raktár és felelős kitöltése kötlező!
                </Alert>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <SelectField
                  required
                  label='Raktár:'
                  tooltip={<CustomTooltip text={getTooltipKeszlet('raktarszuro')} id='raktarszuroTT' />}
                  name="raktar"
                  id="raktar"
                  placeholder="Kezdj el gépelni a kereséshez..."
                  noOptionsMessage={() => 'Nincs keresési eredmény'}
                  searchPromptText="Kezdj el gépelni a kereséshez..."
                  loadingMessage={() => 'Keresés...'}
                  className="basic-single"
                  classNamePrefix="select"
                  onChange={v => this.handleRaktarChange(v)}
                  getOptionLabel={option => option.nev}
                  getOptionValue={option => option.id}
                  value={formRaktar}
                  // isDisabled={isDisabled}
                  // isLoading={isLoading}
                  isClearable
                  isSearchable
                  options={formRaktarOptions}
                />
              </div>
              <div className="col-md-6">
                {existsSzervezet ? (
                    <SelectField
                      label='Felelős:'
                      name="felelos"
                      id="felelos"
                      placeholder="Kezdj el gépelni a kereséshez..."
                      noOptionsMessage={() => 'Nincs keresési eredmény'}
                      searchPromptText="Kezdj el gépelni a kereséshez..."
                      loadingMessage={() => 'Keresés...'}
                      className="basic-single"
                      classNamePrefix="select"
                      onChange={v => this.handleFelelosChange(v)}
                      getOptionLabel={option => option.nev}
                      getOptionValue={option => option.id}
                      value={formFelelos}
                      // isDisabled={isDisabled}
                      // isLoading={isLoading}
                      isClearable
                      isSearchable
                      options={formFelelosOptions}
                      required
                    />
                  ) : (
                    <SelectField
                        varinat='creatable'
                        label='Felelős:'
                        name="formFelelosNev"
                        id="formFelelosNev"
                        placeholder="Kezdj el gépelni a kereséshez..."
                        noOptionsMessage={() => 'Nincs keresési eredmény'}
                        searchPromptText="Kezdj el gépelni a kereséshez..."
                        loadingMessage={() => 'Keresés...'}
                        formatCreateLabel={this.formatCreateLabel}
                        onCreateOption={this.createFelelos}
                        onChange={this.handleFelelosNevChange}
                        getOptionLabel={option => option.label || option}
                        getOptionValue={option => option.value || option}
                        value={formFelelosNev}
                        isClearable
                        isSearchable
                        required
                        options={felelosok}
                      />
                    )}
              </div>
            </div>
            <div className="row" style={{ marginTop: 10 }}>
              <div className="col-md-12">
                <RFField
                  label="Cikkek:"
                  type="text"
                  name="formCikkKereses"
                  autoComplete="off"
                  placeholder="Kezdj el gépelni a kereséshez..."
                  maxLength="350"
                  value={formCikkKereses}
                  onChange={e => this.handleCikkFilter(e)}
                  // disabled={this.props.type === 'MOD'}
                />
              </div>
            </div>
            <div className="row no-gutters">
              {this.state.cikkFilteredTree && this.state.cikkFilteredTree.length > 0 && (
                <>
                  <div className='col-auto' style={{ paddingTop: 2 }}>
                    <input
                      type="checkbox"
                      name={"hasMennyisegCheckbox"}
                      onClick={() => {
                        this.handleCheckAllMennyisegToggle();
                      }}
                      checked={this.state.hasMennyisegCheckbox}
                      id={"hasMennyisegCheckbox"}
                    />
                  </div>
                  <label
                      htmlFor={"hasMennyisegCheckboxLabel"}
                      title={"Minden cikk a raktárban, ahol az aktuális készlet > 0"}
                      style={{ paddingLeft: 5 }}
                      className='col-auto'
                    >
                      Minden cikk a raktárban, ami az aktuális készleten nem nulla
                    </label>
                </>
              )}
                <div className="col-md-12">
                  <TreeView
                    data={this.state.cikkFilteredTree}
                    onUpdateCb={(updatedData) => {
                      this.setState({ cikkFilteredTree: updatedData });
                    }}
                    isCheckable={(node, depth) => {
                      // hide checkbox for all nodes of depth 1
                      // or for node with the id of `1`
                      // NOTE: The highest depth is 0, node children are depth+1
                      if (depth === 2) {
                        return false;
                      }
                      return true;
                    }}
                    onCheckToggleCb={(node, arrayOfNodes, depth) => {
                      const nodeCount = arrayOfNodes.length;
                      const status = (arrayOfNodes[0].isChecked) ? 'checked' : 'unchecked';
                      // alert(`${nodeCount} node(s) will be ${status} ${JSON.stringify(arrayOfNodes[0])} `);
                      if (Array.isArray(arrayOfNodes[0].children)) {
                        this.setState((prevState) => {
                          const checkState = arrayOfNodes[0].isChecked;
                          let cikkTree = JSON.parse(JSON.stringify(prevState.cikkTree));

                          cikkTree.forEach((cikkcsoport) => {
                            if (cikkcsoport.id == node.id) {
                              cikkcsoport.isChecked = checkState;
                              node.cikkek.forEach((cikkNode) => {
                                cikkcsoport.cikkek.forEach((cikk) => {
                                  if (cikk.id == cikkNode.id) {
                                    cikk.isChecked = checkState;
                                  }
                                });
                                cikkcsoport.children.forEach((cikk) => {
                                  if (cikk.id == cikkNode.id) {
                                    cikk.isChecked = checkState;
                                  }
                                });
                              });
                            }
                          });
                          this.handleCikkFilter({
                            target: {
                              type: 'text',
                              value: prevState.formCikkKereses,
                              name: 'formCikkKereses'
                            }
                          }, cikkTree);
                          return { cikkTree };
                        });
                      } else {
                        this.toggleCikkCheck(arrayOfNodes[0].id);
                      }
                    }}
                  />
              </div>
            </div>
          </RFForm>
        </Modal>
        <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.delete()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        {/* <Modal isOpen={this.state.modalKorrekcio} toggle={this.toggleKorrekcioModal} backdrop="static">
          <ModalHeader>Korrekció</ModalHeader>
          <ModalBody>Biztosan végrehajtja a készlet korrekciót? A korrekcióval automatikusan létrehozásra kerülnek a többlet, és hiánynak megfelelő készletnövekedési és készletcsökkenési tételek!</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.korrekcio()}
              loading={this.state.korrekcioButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleKorrekcioModal}>Mégsem</Button>
          </ModalFooter>
        </Modal> */}
        <Modal isOpen={this.state.modalEdit} toggle={this.toggleEditModal} backdrop="static">
          <RFForm onSubmit={() => {}}>
            <ModalHeader>Leltárív módosítása</ModalHeader>
            <ModalBody>
              <div className="row">
                <div className="col-md-12">
                  <Alert color="danger" isOpen={isAlertEditOpen} toggle={this.toggleAlertEdit}>
                    Felelős kitöltése kötlező!
                  </Alert>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  {existsSzervezet ? (
                    <SelectField
                      label='Felelős:'
                      required
                      name="felelos-edit"
                      id="felelos-edit"
                      placeholder="Kezdj el gépelni a kereséshez..."
                      noOptionsMessage={() => 'Nincs keresési eredmény'}
                      searchPromptText="Kezdj el gépelni a kereséshez..."
                      loadingMessage={() => 'Keresés...'}
                      className="basic-single"
                      classNamePrefix="select"
                      onChange={v => this.handleFelelosChange(v)}
                      getOptionLabel={option => option.nev}
                      getOptionValue={option => option.id}
                      value={formFelelos}
                      // isDisabled={isDisabled}
                      // isLoading={isLoading}
                      isClearable
                      isSearchable
                      options={formFelelosOptions}
                    />
                  ) : (
                    <SelectField
                        variant='creatable'
                        label='Felelős:'
                        required
                        name="formFelelosNev"
                        id="formFelelosNev"
                        placeholder="Kezdj el gépelni a kereséshez..."
                        noOptionsMessage={() => 'Nincs keresési eredmény'}
                        searchPromptText="Kezdj el gépelni a kereséshez..."
                        loadingMessage={() => 'Keresés...'}
                        formatCreateLabel={this.formatCreateLabel}
                        onChange={this.handleFelelosNevChange}
                        getOptionLabel={option => option.label || option}
                        getOptionValue={option => option.value || option}
                        value={formFelelosNev}
                        isClearable
                        isSearchable
                        options={felelosok}
                      />
                  )}
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                onClick={() => this.edit()}
                loading={this.state.editButtonLoading}
              >
                {'Mentés'}
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleEditModal}>Mégsem</Button>
            </ModalFooter>
          </RFForm>
        </Modal>
      </React.Fragment>
    );
  }
}

LeltarForm.propTypes = {
  globals: PropTypes.object
};

export default LeltarForm;
